const HomeDivider = () => (
    <div style={{width: '100%', height: "1px", backgroundColor:'rgba(255, 255, 255, 0.08)', margin: "30px 0px"}}>
    </div>
)

export default HomeDivider;